"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MessageReactions = exports.MessageReactionPill = exports.MessageReactionsContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var omni_images_1 = require("@hiyllo/omni-images");
var styled_1 = require("@hiyllo/ux/main/styled");
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
exports.MessageReactionsContainer = (0, styled_1.styledRN)(react_native_1.View, {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 10,
    paddingTop: 2.5,
    width: '100%'
});
var MessageReactionPillContainer = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var $theme = _a.$theme;
    return ({
        backgroundColor: $theme.midground,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
        padding: 5,
        borderRadius: 10
    });
});
var PillImageContainer = (0, styled_1.styledRN)(react_native_1.View, {
    width: 18,
    height: 18,
    overflow: 'hidden',
    flexShrink: 0
});
var PillEmojiContainer = (0, styled_1.styledRN)(react_native_1.Text, {
    fontSize: 12,
    lineHeight: 16
});
exports.MessageReactionPill = react_1["default"].memo(function MessageReactionPill(props) {
    if (props.message.content.encrypted ||
        props.message.content.reaction == null) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    return ((0, jsx_runtime_1.jsxs)(MessageReactionPillContainer, { children: [(0, jsx_runtime_1.jsx)(PillImageContainer, { children: (0, jsx_runtime_1.jsx)(omni_images_1.UserImage, { userId: props.message.senderId, width: 18 }) }), (0, jsx_runtime_1.jsx)(PillEmojiContainer, { children: props.message.content.reaction.reaction })] }));
});
exports.MessageReactions = react_1["default"].memo(function MessageReactions(props) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.reactions.length > 0 ? ((0, jsx_runtime_1.jsx)(exports.MessageReactionsContainer, { children: props.reactions.map(function (message) { return ((0, jsx_runtime_1.jsx)(exports.MessageReactionPill, { message: message }, message.uuid)); }) })) : null }));
});
